var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95418 31.0457 -0.00012207 20 -0.00012207C8.95429 -0.00012207 -1.52588e-05 8.95418 -1.52588e-05 19.9999C-1.52588e-05 31.0456 8.95429 39.9999 20 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 -0.00012207C19.9856 3.41797e-05 19.1306 7.99988 19.1306 7.99988H36.001C32.3522 3.1423 26.5432 -0.00012207 20.0001 -0.00012207Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 39.9999C26.5432 39.9999 32.3522 36.8575 36.001 31.9999H3.99925C7.648 36.8575 13.457 39.9999 20.0001 39.9999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5996 15.9999H19.1306L20.0001 23.9999H39.5996C39.8621 22.7075 40.0001 21.3698 40.0001 19.9999C40.0001 18.63 39.862 17.2923 39.5996 15.9999V15.9999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 23.9999C20 19.826 20 4.6955 20 -0.00012207C8.95436 -0.00012207 -1.52588e-05 8.95425 -1.52588e-05 19.9999C-1.52588e-05 21.3698 0.13811 22.7075 0.400453 23.9999H20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0355 9.56519L12.3305 13.5507H16.5215L13.1312 16.0142L14.426 20L11.0355 17.5367L7.64506 20L8.94013 16.0142L5.54974 13.5507H9.7406L11.0355 9.56519Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogo);
export default __webpack_public_path__ + "static/media/togo.84ddd39e9f08c029d217f7d66c84b893.svg";
export { ForwardRef as ReactComponent };